import { createStore } from "vuex";
import config from "@configs/app";

const store = createStore({
  // Enable strict mode in development
  // In strict mode, error will be thrown when Vuex state is mutated outside of mutation handlers
  // https://vuex.vuejs.org/guide/strict.html
  strict: !config.productionMode,
});
export default store;
